import { ReportDownloadTypeEnumSchema } from "@/Enums/ReportDownloadTypeEnum";
import { z } from "zod";

export const ReportDownloadFileDtoSchema = z.object({
    reportName: z.string().nullable(),
    reportExists: z.boolean(),
    fileType: ReportDownloadTypeEnumSchema,
    group: z.string().nullable(),
    reportsFilePath: z.string().nullable(),
});

export type ReportDownloadFileDto = z.infer<typeof ReportDownloadFileDtoSchema>;

export const CheckReportDownloadStatusOutputSchema = z.object({
    files: z.array(ReportDownloadFileDtoSchema).nullable(),
});

export type CheckReportDownloadStatusOutput = z.infer<typeof CheckReportDownloadStatusOutputSchema>;